<div class="d-flex justify-content-start flex-wrap">
  <div *ngFor="let benefit of benefitsClaimed">
    <fgb-benefit-claimed class="cursor-pointer" [benefit]="benefit" (click)="openModal(benefit)"></fgb-benefit-claimed>
  </div>
  <div class="m-2" *ngFor="let unclaimedBenefit of unclaimedBenefits">
    <span class="unclaimed material-icons align-middle text-secondary" aria-hidden="true">add</span>
  </div>
</div>
